import createjs from 'createjs-collection';
import _, { values, isEmpty } from 'lodash';
// import { base } from './../cjsRoot/cjsBase';

export function customizer(v) {
  if (typeof v === 'object' && v != null && (v._isVue || v instanceof createjs.Stage)) return v;
}

export function isNotEmptyObject(o) {
  return typeof o !== 'undefined' && o !== null && values(o).some((x) => x !== undefined);
}

export function searchTree(node, search) {
  let key = search.shift();
  if (isNotEmptyObject(node[key])) {
    if (search.length === 0) return true;
    return searchTree(node[key], search);
  }
  return search.length === 0 && typeof node[key] !== 'undefined' && node[key] !== null;
}

export function isNumeric(n) {
  return !isNaN(parseFloat(n)) && isFinite(n);
}

export function isEqual(obj1, obj2, checkOnlyLeft) {
  let equal = true;
  for (let i in obj1) {
    equal = obj1[i] !== obj2[i] ? false : equal;
  }
  if (checkOnlyLeft === true) return equal;
  for (let i in obj2) {
    equal = obj1[i] !== obj2[i] ? false : equal;
  }
  return equal;
}

export function findInArray(tab, props) {
  let find = false;
  for (let i = 0; i < tab.length; i++) {
    if (isEqual(props, tab[i], true) !== false) return true;
  }
  return find;
}

export function getDistance(x1, y1, x2, y2) {
  return Math.sqrt(Math.pow(x2 - x1, 2) + Math.pow(y2 - y1, 2));
}

export const removeProps =
  (...propsToFilter) =>
  (obj) => {
    return Object.keys(obj)
      .filter((key) => !propsToFilter.includes(key))
      .reduce((newObj, key) => {
        newObj[key] = obj[key];
        return newObj;
      }, {});
  };

export function removeTags(str) {
  if (typeof str == 'undefined' || str === null || str.length === 0) {
    return false;
  } else {
    str = str.toString();
  }

  return str.replace(/(<([^>]+)>)/gi, '');
}

export class Color {
  _r;
  _g;
  _b;
  _a;

  constructor(obj) {
    if (typeof obj == 'undefined' || obj == null) return;

    this._checkRGB(color);
  }

  _checkRGB(color) {
    let matchColors = /rgb\((\d{1,3}), (\d{1,3}), (\d{1,3})\)/;
    let match = matchColors.exec(color);
    if (match !== null) {
      this._r = match[1];
      this._g = match[2];
      this._b = match[3];
      return true;
    }

    return false;
  }

  colorMixer(rgbA, rgbB, amountToMix) {
    let r = this._colorChannelMixer(rgbA[0], rgbB[0], amountToMix),
      g = this._colorChannelMixer(rgbA[1], rgbB[1], amountToMix),
      b = this._colorChannelMixer(rgbA[2], rgbB[2], amountToMix);
    if (typeof rgbA[3] === 'undefined' || typeof rgbB[3] === 'undefined') {
      return [r, g, b];
    }
    return [r, g, b, this._colorChannelMixer(rgbA[3], rgbB[3], amountToMix)];
  }

  _colorChannelMixer(colorChannelA, colorChannelB, amountToMix) {
    return parseInt(colorChannelA * amountToMix + colorChannelB * (1 - amountToMix));
  }
}

export class Stopwatch {
  _offset;
  _clock;
  _interval;
  _options;

  constructor(obj) {
    this._options = obj || {};
    this._options.delay = this._options.delay || 1;
    this._interval = null;
    this.reset();
  }

  reset() {
    this._clock = 0;
    return this.render();
  }

  render() {
    return this._clock / 1000;
  }

  start() {
    if (!this._interval) {
      this._offset = Date.now();
      let self = this;
      this._interval = setInterval(function () {
        self._update();
      }, this._options.delay);
    }
  }

  stop() {
    if (this._interval) {
      clearInterval(this._interval);
      this._interval = null;
    }
  }

  get isLoading() {
    return this._interval != null;
  }

  _update() {
    this._clock += this._delta();
    return this.render();
  }

  _delta() {
    let now = Date.now(),
      d = now - this._offset;

    this._offset = now;
    return d;
  }
}
